'use client';
import { useMemo } from 'react';
import { round, arrayFrom } from '@s7/utils';

var dynamicMultipliers = function(width) {
    // Чем больше картинка, тем большее кол-во шагов используем
    if (width < 160) {
        return [
            0.5,
            1,
            2
        ];
    }
    if (width < 750) {
        return [
            0.5,
            1,
            1.5,
            2
        ];
    }
    if (width < 1400) {
        return [
            0.25,
            0.5,
            0.75,
            1,
            1.5,
            2
        ];
    }
    return [
        0.25,
        0.5,
        0.75,
        1,
        1.25,
        1.5,
        1.75,
        2
    ];
};
function useResponsiveImage(options) {
    var width = options.width, height = options.height, baseUrl = options.baseUrl, src = options.src, srcPrefix = options.srcPrefix, loader = options.loader;
    return useMemo(function() {
        var srcSetEntries = dynamicMultipliers(width).map(function(multiple) {
            var computedWidth = round(width * multiple);
            var computedHeight = round(height * multiple);
            // Если картинка сильно маленькая, то оптимальнее оставить как есть
            if (multiple < 1 && computedWidth < 50) {
                return null;
            }
            var url = loader ? loader({
                baseUrl: baseUrl,
                src: src,
                srcPrefix: srcPrefix,
                options: {
                    width: computedWidth,
                    height: computedHeight,
                    quality: 90
                }
            }) : src;
            return url + " " + computedWidth + "w";
        }).filter(Boolean);
        return arrayFrom(new Set(srcSetEntries)).join(", ");
    }, [
        width,
        height,
        loader,
        baseUrl,
        src,
        srcPrefix
    ]);
}

export { useResponsiveImage };
